import API from '@sesame/web-api';

import { ISalesorderType } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';

const salesorderTypeList: ISalesorderType[] = [];
let loading = false;

function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getSalesorderTypeCacheList = async (authToken: string): Promise<ISalesorderType[]> => {

  if (salesorderTypeList.length == 0 && !loading) {
    loading = true;
    const response = await API.get(authToken, 'api/v1/salesordertype')
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'SalesorderTypes Not Found');
          return;
        }
        Alert(AlertTypes.ERROR, 'SalesorderTypes: ' + err.message);
      });
    const stList = response.data as ISalesorderType[];
    salesorderTypeList.push(...stList);
    loading = false;
  } else if (loading) {
    await wait(500);
    return getSalesorderTypeCacheList(authToken);
  }
  return salesorderTypeList;
}
